import { useContext, useMemo } from 'react';
import { ApiContext } from '../../contexts/ApiContext';
import Spinner from '../spinner/Spinner';
import Card from "../card/Card";

const HOW_MANY = 6;

export default function CommonSpareParts(){

    // La lista de kits ya viene del context (una sola request para toda la app).
    const { kitMaintenance, loading } = useContext(ApiContext);

    const listCommonSpareParts = useMemo(() => {
        if (!Array.isArray(kitMaintenance)) return [];
        // Copia antes de ordenar: sort muta, y este array es el del context.
        return [...kitMaintenance].sort(() => 0.5 - Math.random()).slice(0, HOW_MANY);
    }, [kitMaintenance]);

    if (loading) {
        return <Spinner />;
    }

    return <Card listCard={listCommonSpareParts} cardStyles={cardStyles} origin='api' />;
}

const cardStyles = {
    width: '100%',
    backgroundColor: 'transparent',
    color: '#FFF'
};
